import { render } from "./InvestorView.html?vue&type=template&id=2b65c7de"
import script from "./InvestorView.js?vue&type=script&lang=js"
export * from "./InvestorView.js?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__